export default "__VITE_ASSET__CjmSdr8U__"